import React, { Component } from 'react';

import PaginationItem from '@material-ui/lab/PaginationItem';

class Pagination extends Component {
    // 부모 컴포넌트에서 getCurrentPage 함수를 사용하여 currentPage 값을 변경하고 list를 다시 받아온다
    // this.props.list 에는 currentPage, totalPage 키값이 포함되어야 함

    handlePreviewPage = async () => {
        this.props.getCurrentPage((this.props.list.currentPage - 1));
    };
    handleNextPage = async () => {
        this.props.getCurrentPage((this.props.list.currentPage + 1));
    };
    handleCurrentPage = async (e) => {
        this.props.getCurrentPage(e.target.value);
    };

    render() {
        const { currentPage, totalPage } = this.props.list;
        let pageArray = [];
        let startPage = 1;
        let endPage = 1;
        if (currentPage <= 6) {
            startPage = 1;
            endPage = (totalPage < 10 ? totalPage : 10);
        }
        else if (currentPage > (totalPage - 4)) {
            startPage = (totalPage - 9) < 0 ? 1 : (totalPage - 9);
            endPage = totalPage;
        }
        else {
            startPage = (currentPage - 5) < 0 ? 1 : currentPage - 5;
            endPage = (startPage + 9);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageArray.push(<PaginationItem key={i} color="primary" type="page" shape="rounded" page={i} value={i} onClick={this.handleCurrentPage} selected={i === currentPage} />);
        }

        return (
            <>
                <br />
                <div className="text-align-center">
                    <PaginationItem className={`${startPage === 1 && "page-hidden"}`} color="primary" type="page" shape="rounded" page={1} value={1} onClick={this.handleCurrentPage} />
                    <PaginationItem color="primary" type="previous" shape="rounded" onClick={this.handlePreviewPage} disabled={currentPage === 1 ? true : false} />
                    {pageArray}
                    <PaginationItem color="primary" type="next" shape="rounded" onClick={this.handleNextPage} disabled={currentPage === totalPage ? true : false} />
                    <PaginationItem className={`${endPage === totalPage && "page-hidden"}`} color="primary" type="page" shape="rounded" page={totalPage} value={totalPage} onClick={this.handleCurrentPage} />
                </div>
            </>
        )
    }
}

export default (Pagination);